import ManipulacaoLoteEstoqueModel from "@/models/manipulacaoLoteEstoqueModel";
import ManipulacaoOrdemItemModel from "@/models/manipulacaoOrdemItemModel";

import nfetch from "../utils/events/nfetch";

class ManipulacaoLoteEstoqueService {
    private controllerName = "ManipulacaoLoteEstoque";

    public atualizarQuantidadeLote(produtos: ManipulacaoLoteEstoqueModel) {
        return nfetch(`/${this.controllerName}/AtualizarQuantidadeLote`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(produtos),
        })
            .withLoading()
            .resolveWithJSON<ManipulacaoOrdemItemModel>();
    }

    public atualizarLote(produtos: ManipulacaoLoteEstoqueModel) {
        return nfetch(`/${this.controllerName}/AtualizarLote`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(produtos),
        })
            .withLoading()
            .resolveWithJSON<ManipulacaoOrdemItemModel>();
    }

    public listProdutosMovimentosVerificados(manipulacaoOrdemId: number) {
        return nfetch(
            `/${this.controllerName}/ListProdutosMovimentosVerificados?manipulacaoOrdemId=${manipulacaoOrdemId}`,
            {
                method: "post",
                credentials: "same-origin",
                headers: {
                    "Content-Type": "application/json; charset=UTF-8",
                },
            },
        )
            .withLoading()
            .resolveWithJSON<Array<ManipulacaoLoteEstoqueModel>>();
    }
}

export default new ManipulacaoLoteEstoqueService();
